export enum EPromotionType {
  /**
   * ### (sp.) Promoción Simple
   */
  SIMPLE_DISCOUNT = 'SIMPLE_DISCOUNT',
  /**
   * ### (sp.) Promoción Escalonada
   */
  TIERED_DISCOUNT = 'TIERED_DISCOUNT',
  /**
   * ### (sp.) Promoción Combo
   */
  COMBO_DISCOUNT = 'COMBO_DISCOUNT',
  /**
   * ### (sp.) Promoción de Bonificación Simple
   */
  SIMPLE_BONUS = 'SIMPLE_BONUS',
  /**
   * ### (sp.) Promoción de Bonificación Escalonada
   */
  TIERED_BONUS = 'TIERED_BONUS',
  /**
   * ### (sp.) Promoción de Bonificación Combo
   */
  COMBO_BONUS = 'COMBO_BONUS',
}

export enum EPromotionSearchMethod {
  CODE = 'CODE',
  FILTER = 'FILTER',
}

export enum EPromotionDetailType {
  DISCOUNT = 'DISCOUNT',
  BONUS = 'BONUS',
}

export enum EPromotionDetailSubType {
  SIMPLE = 'SIMPLE',
  TIERED = 'TIERED',
  COMBO = 'COMBO',
}

export enum EPromotionStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  PUBLISHED = 'PUBLISHED',
}

export enum EPromotionConditionType {
  QUANTITY = 'qty',
  AMOUNT = 'amt',
}
